import { computed } from 'vue'

/**
 * CE QUI SERA ENREGISTRÉ, et non ce qui a été chargé.
 *
 * Une section confirmée repasse en lecture seule, et ses composants affichent
 * alors `quote` : une adresse corrigée puis confirmée réapparaissait telle
 * qu'avant la correction, alors que c'est bien la corrigée qui part à
 * l'enregistrement. En édition, `editedQuote` est une copie complète de la
 * demande : il suffit à l'affichage.
 *
 * @param {import('vue').Ref<Object|null>} quote - Demande chargée.
 * @param {import('vue').Ref<Object>} editedQuote - Copie en cours d'édition.
 * @param {import('vue').Ref<boolean>} isEditing - Édition en cours.
 * @returns {import('vue').ComputedRef<Object|null>}
 */
export function useShownQuote(quote, editedQuote, isEditing) {
  return computed(() => (
    isEditing.value && editedQuote.value && Object.keys(editedQuote.value).length
      ? editedQuote.value
      : quote.value
  ))
}
